// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__M8XtI","addWidgetButton":"Header_addWidgetButton__25HB_","dashboardTabs":"Header_dashboardTabs__2q1T8","active":"Header_active__2qU_L"};